import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { myEpikBaseURL, unifiedBaseURL } from '../lib/api/api';

/**
 * Custom React hook for fetching data from a specified API endpoint using Axios.
 *
 * @param {string} endpoint - The API endpoint to be called.
 * @param {boolean} enabled - A flag to determine if data fetching is enabled on component render (default is true).
 * @returns {object} - An object containing loading state, fetched data, and a fetchData function.
 */

export function useUnifiedFetch(endpoint, enabled = true, isMyEpik) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState();
  const [error, setError] = React.useState();

  const fetchData = React.useCallback(async (params = {}, method = 'GET', body = null, responseType = 'json') => {
    if (!endpoint) {
      return;
    }
    const hasUnifiedOrPort = url => {
      return url.includes('unified') || url.includes('3002');
    };

    try {
      setIsLoading(true);

      const url = `${isMyEpik ? myEpikBaseURL : unifiedBaseURL()}${
        process.env.REACT_APP_UNIFIED_API_VERSION
      }/${endpoint}`;

      const addCookie = (url.includes('unified') || url.includes('3002')) ? false : true
      console.log({ addCookie });

      const token = localStorage.getItem('jwtToken') || null;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await axios.get(url, {
        ...(addCookie && { withCredentials: true }),
        headers,
        params,
        responseType
      });

      setData(data);

      return data;
    } catch (err) {
      let e = err?.response?.data;
      if ([404, 502, 400].includes(err?.response?.status)) {
        e = 'Data fetch error: Some functionality may be affected.';
      }
      setError(e);
      console.log(JSON.stringify(err?.response?.data));
      return {
        status: false, 
        message: err?.response?.data || err?.message
      }
    } finally {
      setIsLoading(false);
    }
  }, [endpoint]);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    fetchData();
  }, [endpoint, enabled, fetchData]);

  return { isLoading, data, fetchData, error };
}
